import React from 'react';
import { FileUploadPanel } from '../FileUploadPanel';
import { DocumentsList } from '../DocumentsList';
import type { useApplicationDetail } from '../../hooks/useApplicationDetail';

interface Props { h: ReturnType<typeof useApplicationDetail>; }

export const DocumentsSection: React.FC<Props> = ({ h }) => {
  const { id, documentsRefreshTrigger } = h;
  if (!id || isNaN(parseInt(id))) return null;

  return (
    <div className="space-y-6">
      <FileUploadPanel
        applicationId={parseInt(id)}
        onUploadComplete={() => h.setDocumentsRefreshTrigger(prev => prev + 1)}
      />
      <DocumentsList
        applicationId={parseInt(id)}
        refreshTrigger={documentsRefreshTrigger}
      />
    </div>
  );
};
